import React from 'react'

interface EmptyStateProps {
  text?: string
  icon?: React.ReactNode
  className?: string
}

export default function EmptyState({ 
  text,
  icon,
  className = '' 
}: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center pt-16 ${className}`}>
      {/* 图标 */}
      {icon ? (
        <div className="mb-4">
          {icon}
        </div>
      ) : (
        <div className="mb-4">
          <img  src="/icon/empty.svg" alt="empty" />
        </div>
      )}
      
      {/* 主文本 */}
      <div className="text-gray-400 text-sm mb-2">{text}</div>
    </div>
  )
}
